module.exports = __webpack_public_path__ + "static/media/header-image.5cdd9a83.svg";